import DynamicDocumentTab from '@cp/pages/CaseDetails/components/AllDocumentsV2/components/DynamicDocumentTab';
import { Documents } from '@cp/src/pages/CaseDetails/components/AllDocumentsV2/documentsSlice';
import { DocContentType } from '@cp/pages/CaseDetails/components/AllDocumentsV2/types';

type TabType = {
  key: string;
  value: string;
  component: React.ReactNode;
};

export const createDynamicTabs = (documents: Documents, isSnoozed: boolean | undefined) => {
  if (Object.keys(documents?.documentDetails || {}).length === 0) {
    return [];
  }
  const tabs: TabType[] = [];

  if (isSnoozed) {
    if (documents?.documentDetails?.NAVI) {
      tabs.push({
        key: documents?.documentDetails?.NAVI?.tabKey || '',
        value: documents?.documentDetails?.NAVI?.tabName || '',
        component: (
          <DynamicDocumentTab
            documentTabKey={documents?.documentDetails?.NAVI?.tabKey || ''}
            key={documents?.documentDetails?.NAVI?.tabKey}
          />
        )
      });
    }
    return tabs;
  }

  Object.keys(documents?.documentDetails || {}).forEach(key => {
    tabs.push({
      key: documents?.documentDetails?.[key]?.tabKey || '',
      value: documents?.documentDetails?.[key]?.tabName || '',
      component: (
        <DynamicDocumentTab
          documentTabKey={documents?.documentDetails?.[key]?.tabKey || ''}
          key={documents?.documentDetails?.[key]?.tabKey}
        />
      )
    });
  });
  return tabs;
};

export const fileTypeToLabel = (type: DocContentType) => {
  switch (type) {
    case DocContentType.PDF:
      return 'Documents';
    case DocContentType.IMAGE:
      return 'Images';
    case DocContentType.VIDEO:
      return '';
    default:
      return 'Document';
  }
};
